import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadMessages, locale } from 'devextreme/localization';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Configurar DevExtreme en español
import esMessages from 'devextreme/localization/messages/es.json';
loadMessages(esMessages);
locale('es');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
